import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Button,
} from "@mui/material";
import React from "react";
import { isValidEmail } from "../utils/util";

const AddEmailDialog = ({
    isAddEmailDialogOpen,
    handleCloseAddEmailDialog,
    newEmail,
    setNewEmail,
    handleSaveNewEmail,
}: {
    isAddEmailDialogOpen: boolean;
    handleCloseAddEmailDialog: () => void;
    newEmail: string;
    setNewEmail: React.Dispatch<React.SetStateAction<string>>;
    handleSaveNewEmail: () => void;
}) => {
    return (
        <Dialog open={isAddEmailDialogOpen} onClose={handleCloseAddEmailDialog}>
            <DialogTitle>Add new reciever email</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="newEmail"
                    label="E-postadress"
                    type="email"
                    fullWidth
                    variant="outlined"
                    value={newEmail}
                    onChange={e => setNewEmail(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseAddEmailDialog}>Avbryt</Button>
                <Button
                    onClick={handleSaveNewEmail}
                    variant="contained"
                    disabled={!isValidEmail(newEmail)}
                >
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddEmailDialog;
